import { StageInvite } from "../types";
import { BaseService } from "./baseService";

export interface StageCommentator {
  displayName: string;
  publicHandle: string; // Add publicHandle for API calls
  avatarUrl: string;
  isHost: boolean;
  inviteAccepted: boolean;
}

export class InviteService extends BaseService {
  static async getStageInvites(): Promise<StageInvite[]> {
    try {
      const response = await this.get("/stages/invites");

      if (!response.ok) {
        throw new Error(`Failed to fetch stage invites: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching stage invites:", error);
      throw error;
    }
  }

  static async acceptStageInvite(groupId: string): Promise<void> {
    try {
      const response = await this.post("/stages/invites/accept", {
        groupId,
      });

      if (!response.ok) {
        throw new Error(`Failed to accept stage invite: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Error accepting stage invite:", error);
      throw error;
    }
  }

  static async getStageCommentators(
    groupId: string
  ): Promise<StageCommentator[]> {
    try {
      const response = await this.get(`/stages/invites/${groupId}`);

      if (!response.ok) {
        throw new Error(
          `Failed to fetch stage commentators: ${response.statusText}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching stage commentators:", error);
      throw error;
    }
  }
}
